import FeatureToggleUtils from 'FeatureToggleUtils';
import {
    getTimeFromSessionStartInSeconds,
    buildRecordsUrls,
    videoOrigins,
    playingComponent
} from '../../sessionBroadcastUtils';

export const initialPlayerConfigs = {
    controls: ['mute', 'volume', 'captions', 'settings', 'airplay', 'fullscreen'],
    settings: ['captions', 'quality'],
    clickToPlay: false,
    muted: false,
    storage: { enabled: false },
    captions: { active: false },
    keyboard: { focused: false, global: false },
};

export const clsSimuliveButton = 'join-broadcast-btn bz-button font-size-12 custom-color color-1-background simulive-btn';

export const getVersionToScriptUrls = () => ({
    plyr: FeatureToggleUtils.getFeatureValue('bap-plyr-io-version'),
    hls: FeatureToggleUtils.getFeatureValue('bap-hls-js-version'),
    mux: FeatureToggleUtils.getFeatureValue('bap-mux-player-version'),
});


export const detectVideoOrigin = (rawRecordUrl) => {
    if (rawRecordUrl?.includes('cloudinary.com')) {
        return videoOrigins.CLOUDINARY;
    } else if (rawRecordUrl?.includes('kaltura.com')) {
        return videoOrigins.KALTURA;
    }
    return undefined;
};

export const buildVideoUrls = (rawRecordUrl, hlsEnabled) => {
    const videoOrigin = detectVideoOrigin(rawRecordUrl);
    const shouldLoadHls = hlsEnabled && videoOrigin === videoOrigins.CLOUDINARY;

    return {
        recordUrls: buildRecordsUrls({
            rawRecordUrl,
            hlsEnabled,
            videoOrigin,
            context: playingComponent.PrerecordedVideo
        }),
        shouldLoadHls
    };
};

// This solved Safari iOS issues with current time, fixing bug:SUPP-6851
export const createPlayVideoWithSessionOffset = (playerRef, startDate, startMinute, timeZone) => (
    async function() {
        await playerRef.current.play();
        playerRef.current.pause();
        playerRef.current.currentTime = getTimeFromSessionStartInSeconds({
            startDate,
            startMinute,
            eventTimeZone: timeZone
        });
        playerRef.current.play();
    }
);

